<style lang="scss">
.input-wrapper {
  position: relative;
  max-height: 100% !important;

  .v-input__slot {
    border-radius: 12px;
  }

  .v-input {
    border: 1px solid var(--v-secondary-base);
    background-color: #fff;
    border-radius: 12px;
    padding: 0 16px !important;
    // height: 60px !important;
  }

  input {
    position: relative;
    width: 100%;
    margin: 0 !important;
    // min-height: 60px;
    font-weight: 600;
    font-size: 18px;
    text-align: left;
    letter-spacing: 0.3px;
    color: #0A0A0D;
    transition: 0.2s;

    &::placeholder {
      font-weight: 400;
      color: #6C6C6E;
    }

    &:focus {
      border-color: #91DC60;
    }
  }

  .hide-icon {
    position: absolute;
    right: 19px;
    top: 50%;
    cursor: pointer;
    transform: translate(0%, -50%);
  }

  &.input-code {
    input {
      padding-right: 16px;
      //padding: 16px 40px;
      text-align: center;
    }
  }

  .v-text-field__details {
    min-height: 0 !important;
    transition: 0.3s;
    margin-bottom: 0px !important;

    .v-messages {
      min-height: 0;

      &.error--text {
        margin-bottom: 6px;
        margin-top: 6px;
      }
    }
  }

  .v-input__slot {
    padding: 0 !important;
    margin: 0 !important;
    background-color: transparent !important;
  }
}

</style>

<template>
  <v-col v-bind="grid" class="mb-0 pb-0 pt-2">
    <v-expand-transition>
      <component
        :is="fieldTypes[field.fieldType || 'text']"
        v-if="!(field.visible === false)"
        v-model="field.value"
        v-bind="field"
        @input="field.input"

        :class="[ anketaName, style, 'mt-10']"
        :fieldHeight="fieldHeight"
      ></component>
    </v-expand-transition>
  </v-col>
</template>

<script>
import slider from "./fields/Slider.vue";
// import codeSMS from "./fields/СodeSMS";
import checkbox from "./fields/Checkbox";
import select from "./fields/Select";
import gender from "./fields/Gender";
import text from "./fields/Text";
import date from "./fields/Date";
import autocomplete from "./fields/Autocomplete";
import vautocomplete from "./fields/VAutocomplete";

export default {
  props: {
    anketaName: String,
  },
  computed: {
    field() {
      return this.$anketa[this.anketaName];
    },
    fieldHeight() {
        let height = {
          'xs': 75,
          'sm': 75,
          'md': 45,
          'lg': 45,
          'xl': 60
        }

      return ((height[this.$vuetify.breakpoint.name] || 60)+2)+"px";
    },
    grid() {
      return this.field?.grid || { cols: 12 };
    },
    style() {
      // Базовая стилизация поля 
      const type = this.field.fieldType || 'text';     
      const styles = {
        autocomplete: 'input-wrapper input-text mt-3',
        text: 'input-wrapper input-text mt-4',
        date: 'input-wrapper input-text mt-3',
        select: 'input-wrapper'
      };

      return styles[type];
    }
  },
  data: () => ({
    fieldTypes: {
        slider,
        text,
        select,
        gender,
        checkbox,
        date,
        autocomplete,
        vautocomplete
    },
  }),
}
</script>